import {ChangeDetectionStrategy, Component, inject, OnInit} from '@angular/core';
import {AuthenticationService} from '../../service/authentication.service';
import {IconComponent} from '../icon/icon.component';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'ucs-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IconComponent, TranslatePipe]
})
export class LogoutComponent implements OnInit {
  private authenticationService = inject(AuthenticationService);

  ngOnInit(): void {
    this.authenticationService.logout();
  }
}

